import "./list-clinic-schedule.scss";

import { useUserIdentityContext } from "@core/services/user-identity.context";
import { useParams } from "react-router-dom";

import { ScheduleExceptionsManager } from "../schedule-exceptions-manager/schedule-exceptions-manager";
import { WeeklyScheduleManager } from "../weekly-schedule-manager/weekly-schedule-manager";

export function ListClinicSchedule() {
  const { getAuthUser, getUserRole } = useUserIdentityContext();
  //   const tenant = getAuthUser().slug;
  //   const { tenant } = getUserRole();
  // const tenant = "6e142d92-101d-4a86-bddd-3eed5a51a50d";
  const { client: tenant = "" } = useParams<{ client: string }>();

  return (
    <div className="list-clinic-schedule">
      <div className="page-header">
        <h1>Clinic Schedule Management</h1>
        <p>Configure your clinic's operating hours and manage closures</p>
      </div>

      <div className="schedule-sections">
        <div className="section-card">
          <div className="section-header">
            <i className="pi pi-calendar"></i>
            <h2>Weekly Operating Hours</h2>
          </div>
          <div className="section-content">
            <WeeklyScheduleManager tenant={tenant} />
          </div>
        </div>

        <div className="section-card">
          <div className="section-header">
            <i className="pi pi-calendar-times"></i>
            <h2>Holidays &amp; Closures</h2>
          </div>
          <div className="section-content">
            <ScheduleExceptionsManager tenant={tenant} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListClinicSchedule;
